import CommunityService from "../../services/communityService";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import NotificationService from "../Notification/notificationService";
import DialogService from "../Dialog/dialogService";
import { Link } from "react-router-dom";

interface NewMessageProps {
  isOffer?: boolean;
  shirtName?: string;
  targetUser: Number;
}

const NewMessage = ({ isOffer, shirtName, targetUser }: NewMessageProps) => {
  const [offer, setOffer] = useState<string | undefined>(undefined);
  const [text, setText] = useState<string>("");

  const { createChannel, sendMessage } = CommunityService();
  const { success, error } = NotificationService();
  const { close } = DialogService();

  const titleStyle = {
    color: "black !important",
    fontWeight: "700  !important",
    fontSize: "1.2rem !important",
  };

  const submitMessage = () => {
    if (isOffer === true && shirtName) {
      if (offer) {
        createChannel(String(targetUser)).then(function (data) {
          sendMessage(data.channelId, offer).then((result) => {
            success("Offer sent");
            close();
          });
        });
      } else {
        error("offer cannot be empty.");
      }
    } else {
      if (text !== "") {
        createChannel(String(targetUser)).then(function (data) {
          sendMessage(data.channelId, text).then((result) => {
            success("Message sent");
            close();
          });
        });
      } else {
        error("Text message cannot be empty.");
      }
    }
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item container direction="column" marginBottom={2}>
        {isOffer === true && shirtName !== undefined && (
          <Grid item>
            <TextField
              required
              label={""}
              variant="outlined"
              type="text"
              fullWidth
              margin="normal"
              value={offer}
              placeholder="Make an offer to buy or trade"
              onChange={(e) => setOffer(e.target.value)}
            />
          </Grid>
        )}
      </Grid>

      <Grid container direction="row" justifyContent="flex-end" columnGap={1}>
        <Grid item>
          <Button onClick={close} variant="outlined">
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={submitMessage}
            sx={{
              backgroundColor: "#2c4ce7",
              color: "#fff",
              paddingX: "1.5rem",
            }}
          >
            Send
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NewMessage;
